/**
 * Created by BFR on 18/04/2019.
 */
define('sampleIdsQcController',[
  'module',
  'logger',
  'underscore',
  'app',
  'sampleIdsQcView',
  'entities/runs'
], function(
  module,
  Logger,
  _,
  App,
  View
) {
  'use strict';

  var SampleIdsQcController = {
    showSampleIds: function(runSecId, sampleId, assaySecId, mbAModelSecId) {
        this.view = new View({
            runSecId: runSecId,
            sampleId: sampleId,
            assaySecId: assaySecId,
            mbAModelSecId: mbAModelSecId
        });
        App.regions.getRegion('main').currentView.getRegion('content').show(this.view);
    }
  };

  module.exports = SampleIdsQcController;
});
